<template>
  <div
    id="signals"
    class="current_page"
    :class="{
      activeUser: loggedAndActive,
      registrationMessageModalActive: showMessageModal,
      SignalsLoaded: !noItemsAvailable
    }"
  >
    <SignalModal v-if="showSignalModal" />
    <NotificationModal title="Signal_Validity" content="Signal_validity_info" />
    <section>
      <div class="container adjusted-container-width px-md-3">
        <div class="background-wrapper" v-if="showBanner">
          <div class="background">
            <div class="close" @click="hideAd()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <defs></defs>
                <rect class="a" width="24" height="24" />
                <g transform="translate(5.153 5.431)">
                  <g transform="translate(0 0)">
                    <rect
                      class="b"
                      width="17.423"
                      height="2.376"
                      transform="translate(0 12.32) rotate(-45)"
                    />
                  </g>
                  <rect
                    class="b"
                    width="17.423"
                    height="2.376"
                    transform="translate(1.68 0) rotate(45)"
                  />
                </g>
              </svg>
            </div>
            <div class="ad">
              <h1>{{ t("Signals_banner_title") }}</h1>
              <h3>
                {{ t("Signals_banner_body") }}
              </h3>
              <div class="btn" @click="scrollToForm">
                {{ t("Signals_banner_cta") }}
              </div>
            </div>
            <!--          <img class="wave" src="../../assets/images/components/signals/bg.png">-->
            <img
              class="hand desktop"
              src="../../assets/images/components/signals/phone_hand_desktop.png"
            />
            <img
              class="hand mobile"
              src="../../assets/images/components/signals/phone_hand_mobile.png"
            />
          </div>
        </div>
        <div class="header-container">
          <h3>{{ t("Signals_label") }}</h3>
          <FilterSignals></FilterSignals>
          <!--          <FilterSignals :authorisedSignals="getCheckedSignals"></FilterSignals>-->
        </div>
        <div
          v-infinite-scroll=""
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
          infinite-scroll-immediate-check="false"
        >
          <div
            class="row row-cols-1 row-cols-md-2 row-cols-lg-3 mx-md-n3 cards-wrapper paywall"
            :class="{ empty: !displayedSignalsRefferingSingleItem.length }"
          >
            <CardSignal
              v-for="(signal, index) in displayedSignalsRefferingSingleItem"
              :key="index"
              :signal="signal"
              :price="quotes[signal.symbol]"
              :blur="shouldItemBlurred(index)"
              class="px-md-3"
            />
          </div>
        </div>
        <div
          class="more-signals-wrapper row row-cols-md-3 row-cols-lg-3 mx-md-n3"
          v-if="loggedAndActive && moreSignalsAvailable && !symbol"
        >
          <div class="btn-wrapper">
            <button @click="updateSignalsList">{{ t("more_signals") }}</button>
          </div>
        </div>
        <div class="login-register-wrapper">
          <!--          v-show for login-register-wrapper, in order to avoid collision of the form with other elements before the signals were loaded-->
          <LoginOrRegister />
        </div>
      </div>
    </section>
    <available-soon
      :noItemsAvailable="noItemsAvailable"
      itemType="signals"
    ></available-soon>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Vue from "vue";
import CardSignal from "../../components/itemCard/CardSignal";
import FilterSignals from "../../components/FilterSignals";
import LoginOrRegister from "../../components/LoginOrRegister";
import SignalModal from "@/components/SignalModal";
import { scrollToForm } from "@/utils/general";
import infiniteScroll from "vue-infinite-scroll";
import availableSoon from "@/views/plus/itemList/sharedComponents/noAvailableItems";
import NotificationModal from "@/components/NotificationModal";

Vue.use(infiniteScroll);

export default {
  name: "Signals",
  props: ["symbol"],
  data() {
    return {
      showAd: true
    };
  },
  components: {
    LoginOrRegister,
    CardSignal,
    FilterSignals,
    SignalModal,
    availableSoon,
    NotificationModal
  },
  computed: {
    ...mapState("signals", [
      "signals",
      "sortedSignalsFromService",
      "symbols",
      "showSignalModal",
      "displayedSignals",
      "busy"
    ]),
    ...mapState("symbolsSocket", ["quotes"]),
    ...mapState(["isLoggedIn", "userStatusReturned", "userStatusReturned"]),
    //note: its not optimal to use 'showMessageModal' here, but it has used because this element alternates the login form's z-index which affects the message modal
    ...mapState("loginOrRegister", ["showMessageModal"]),
    ...mapGetters("signals", ["checkedSignals", "moreSignalsAvailable"]),
    ...mapGetters(["t", "loggedAndActive", "isLoaderActive"]),
    signalsAndUserstatus() {
      return `${this.sortedSignalsFromService}|${this.userStatusReturned}`;
    },
    getCheckedSignals() {
      return this.checkedSignals;
    },
    showBanner() {
      if (this.isLoggedIn) {
        return false;
      } else {
        return this.showAd;
      }
    },
    noItemsAvailable: function() {
      return Array.isArray(this.signals) && this.signals.length == 0;
    },
    displayedSignalsRefferingSingleItem: function() {
      const that = this;
      if (!this.symbol) {
        return this.displayedSignals;
      } else {
        //not an ideal solution, but the system's structure wasn't orignially planned for representing single item at this page
        return this.signals.filter(function(item) {
          return item.symbol == that.symbol;
        });
      }
    }
  },
  watch: {
    signals() {
      //if theres a symbol prop, initialize only if the symbols list includes it, otherwise its irrelevant (added because it might be just general list which dosen't includues th symbol, and breaking the top section at instruments page) - different solution might be required for future cases
      if (
        !this.symbol ||
        (this.symbols && Object.keys(this.symbols).includes(this.symbol))
      ) {
        this.completeSocketInitialization(Object.keys(this.symbols));
      }
    },
    signalsAndUserstatus() {
      //we need both signals and user status before initiation. if one of them change check if both where updated
      if (
        this.sortedSignalsFromService.length !== 0 &&
        this.userStatusReturned
      ) {
        this.loadUserSignals();
      }
    },
    checkedSignals() {
      this.initSignalList();
    }
  },
  methods: {
    ...mapMutations([
      "incrementPendingApiCallsCount",
      "decrementPendingApiCallsCount",
      "hideComponentMountLoader"
    ]),
    ...mapActions(["getInfoFromWebsite"]),
    ...mapActions("symbolsSocket", ["completeSocketInitialization"]),
    ...mapActions("signals", [
      "loadUserSignals",
      "getSignalsFromService",
      "initSignalList",
      "updateSignalsList"
    ]),
    hideAd: function() {
      this.showAd = false;
    },
    scrollToForm: function() {
      // let el = document.getElementById("alvexoPlusForm");
      // let calcHight = window.innerWidth > 600  ? el.offsetTop : el.offsetTop-40;
      // window.scrollTo(0, calcHight);
      scrollToForm();
    },
    shouldItemBlurred: function(cardIndex) {
      if (!this.symbol) {
        return cardIndex > 2 && !this.loggedAndActive;
      } else {
        return !this.loggedAndActive;
      }
    }
  },
  created() {
    this.getInfoFromWebsite("symbols");
    this.getSignalsFromService(this.symbol);
  },
  mounted() {
    this.hideComponentMountLoader();
  }
};
</script>

<style lang="scss" scoped>
$cardWidth: 20.5rem;
#signals {
  padding-bottom: 40px;
  &.SignalsLoaded:not(.activeUser) {
    .cards-wrapper {
      margin-bottom: -246px;
      & > div.blur {
        margin-bottom: 0;
        z-index: -1;
      }
    }
  }
  &:not(.registrationMessageModalActive) .container {
    z-index: 1;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem 0 0;
    margin-bottom: 1.5rem;
    h3 {
      color: #4a4a4a;
    }
  }
  .login-register-wrapper {
    max-width: 742px;
    margin: 0 auto;
  }
  .background-wrapper {
    background-color: #f2f2f2;
    margin-top: 20px;
    margin-bottom: 3.375rem;
  }
  .background {
    z-index: 0;
    &:before {
      content: "";
      width: 100%;
      height: 100%;
      background-position: right;
      position: absolute;
      background-image: url("../../assets/images/components/signals/bg.png");
      z-index: -1;
    }
    width: 100%;
    height: 250px;
    position: relative;
    .close {
      position: absolute;
      top: 7px;
      right: 8px;
      opacity: 1;
      z-index: 2;

      &:hover {
        cursor: pointer;
      }

      .a {
        fill: none;
      }

      .b {
        fill: #f2f2f2;
        stroke: rgba(0, 0, 0, 0);
        stroke-miterlimit: 10;
      }
    }
    .ad {
      padding-left: 2.375rem;
      padding-top: 3rem;
      position: relative;
      z-index: 1;

      h1 {
        font-size: 2.25rem;
        font-weight: bold;
      }

      h3 {
        margin-top: 0.875rem;
        font-size: 1.5rem;
        font-weight: normal;
      }

      .btn {
        width: 230px;
        height: 40px;
        margin-top: 27px;
        background: #1c79be;
        border: 1px solid #1c79be;
        font-size: 1rem;
        color: #ffffff;
        border-radius: 3px;
        text-transform: uppercase;
      }
    }
    .wave {
      width: 100%;
      bottom: 0;
      position: absolute;
    }
    .hand {
      &.mobile {
        display: none;
        width: 140px;
      }

      bottom: 0;
      left: 680px;
      position: absolute;
    }
  }
  .row {
    max-width: 1104px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .cards-wrapper {
    & > div {
      margin-bottom: 30px;
    }
  }
  .more-signals-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    @media only screen and (max-width: 768px) {
      margin-top: 0px;
    }
    .btn-wrapper {
      padding-right: 1rem;
      padding-left: 1rem;
      @media only screen and (max-width: 768px) {
        min-width: 190px;
      }
      button {
        width: 100%;
        background-color: transparent;
        border: 1px solid #7a7c7c;
        border-radius: 3px;
        height: 40px;

        color: #424242;
        font-weight: 500;
        &:focus {
          outline: none;
        }
        &:hover {
          background-color: #1c79be;
          color: #ffffff;
          border: none;
        }
        &:first-letter {
          text-transform: uppercase;
        }
      }
    }
  }
}

.ar {
  #signals {
    .background {
      &:before {
        -moz-transform: scaleX(-1);
        -o-transform: scaleX(-1);
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
        filter: FlipH;
        -ms-filter: "FlipH";
      }
      .ad {
        padding-right: 2.375rem;
        padding-left: 0;
      }
      .hand {
        right: 680px;
        left: auto;
      }
      .close {
        left: 8px;
        right: auto;
      }
    }
  }
}

.fr,
.es,
.pt,
.it,
.de {
  #signals {
    .background {
      .ad {
        h1 {
          font-size: 1.375rem;
        }
        h3 {
          max-width: 60%;
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) {
  .header-container {
    margin-left: 1rem;
  }
}
@media only screen and (max-width: 1030px) {
  #signals .background {
    .ad {
      h3 {
        max-width: 66%;
      }
    }
    .hand {
      left: initial;
      right: 20px;
    }
  }
  .ar #signals {
    .background {
      .hand {
        left: 20px;
        right: initial;
      }
    }
  }
  .fr,
  .es,
  .pt,
  .it,
  .de {
    #signals {
      .background {
        .ad {
          max-width: calc(100% - 246px);
          h1 {
            font-size: 1.25rem;
          }
          h3 {
            font-size: 1.25rem;
            max-width: 96%;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 890px) {
  #signals .background {
    .hand {
      right: 0;
    }
    .ad {
      h1 {
        font-size: 1.5rem;
      }

      h3 {
        max-width: 60%;
        font-size: 1.25rem;
      }
    }
  }
  .ar #signals {
    .background {
      .hand {
        left: 0;
        right: auto;
      }
    }
  }
  .fr,
  .es,
  .pt,
  .it,
  .de {
    #signals {
      .background {
        .ad {
          h1 {
            max-width: calc(100% - 12px);
            font-size: 1rem;
          }
          h3 {
            font-size: 1rem;
            max-width: calc(100% - 70px);
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  #signals {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 1.5rem;
    &.SignalsLoaded:not(.activeUser) {
      .cards-wrapper {
        margin-bottom: -36px;
      }
    }
    .container {
      padding-right: 0;
      padding-left: 0;
      margin-right: 0;
      margin-left: 0;
      max-width: 100%;
    }
    .header-container {
      padding: 0;
      margin-top: 1.5rem;
      margin-right: auto;
      margin-left: auto;
      max-width: $cardWidth;
      h3 {
        font-size: 1.25rem;
        height: auto;
      }
    }
    .cards-wrapper,
    .more-signals-wrapper {
      max-width: $cardWidth;
    }
    .cards-wrapper {
      margin: 0;
      & > div {
        &:last-of-type {
          margin-bottom: 1.5rem;
        }
      }
    }
  }

  .fr,
  .es,
  .pt,
  .it,
  .de {
    #signals {
      .background {
        .ad {
          padding-top: 1rem;

          h3 {
            margin-top: 0.75rem;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 665px) {
  #signals {
    padding-top: 0;
    .background-wrapper {
      margin-top: 0;
      margin-bottom: 0;
      .background {
        padding: 0;
        &:before {
          background-position-x: 72%;
        }
        .close {
          height: 14px;
          .b {
            fill: #cbcbcb;
          }
        }
        .hand {
          &.mobile {
            display: block;
            right: 0px;
          }

          &.desktop {
            display: none;
          }
        }
      }
    }
  }
  .ar {
    #signals {
      .background-wrapper {
        .background {
          .hand {
            &.mobile {
              display: block;
              left: 0;
              right: auto;
            }
          }
        }
      }
    }
  }
  .fr,
  .es,
  .pt,
  .it,
  .de {
    #signals {
      .background {
        .ad {
          max-width: none;
          h1 {
            max-width: calc(100% - 28px);
          }
          h3 {
            max-width: calc(100% - 118px);
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 640px) {
  #signals .background {
    height: 231px;
    .ad {
      padding-left: 1.25rem;
      padding-top: 1.375rem;

      h1 {
        font-size: 1.125rem;
      }

      h3 {
        font-size: 1rem;
        max-width: 80%;
      }

      .btn {
        width: 176px;
        margin-top: 20px;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .ar #signals {
    .background {
      .ad {
        padding-right: 1.25rem;
        padding-left: 0;
      }
    }
  }
  .pt #signals {
    .background {
      .ad {
        .btn {
          width: 210px;
        }
      }
    }
  }
}

@media only screen and (max-width: 400px) {
  .fr,
  .es,
  .pt,
  .it,
  .de {
    #signals {
      .background {
        .ad {
          h1 {
            font-size: 1.125rem;
          }
          h3 {
            font-size: 1rem;
          }
          .btn {
            margin-top: 14px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 360px) {
  .fr,
  .es,
  .pt,
  .it,
  .de {
    #signals {
      .background {
        .ad {
          h1 {
            font-size: 1.125rem;
          }
          h3 {
            font-size: 0.875rem;
          }
        }
      }
    }
  }
}
</style>
